import React from 'react';
import { Select } from 'antd';
import { Button } from '@progress/kendo-react-buttons'
import { Input } from '@progress/kendo-react-inputs';
import services from '../../../services';
import { toast } from 'react-toastify';
import InstructionMessage from '../../VidimaModule/Modal/InstructionMessage';
import { data } from 'jquery';
import $ from 'jquery';
import { DownCircleTwoTone } from '@ant-design/icons'

const { Option } = Select

const message = "Nesta área serão definidas as regras a executar sobre os movimentos de conta corrente. Nesta definição serão criados as condições para permitir e executar as operações a realizar sobre conta corrente."
const message2 = "Nesta área serão definidas as regras a executar sobre os tipos de movimentos de conta corrente."

class Nivel2Form extends React.Component {

  state = {
    filters: {
      Filters: null,
      SortBy: "",
      IsSortTypeDESC: false,
      IsPagination: false,
      Page: 2,
      PageSize: 2
    },
    movemento: [],
    tipoFormulario: [],
    dadosMovimento: [],
    codEstatuto: '',
    estatuto: [],
    produtosFormulario: [],
    produtosDestinoFormulario: [],
    produtosTpContaFormulario: [],
    produtosTpContaDestinoFormulario: [],
    regrasMovimento: [],
    regrasMovimentoForm: [
      { name: "mencaoComplementar", displayName: "Menção Complementar", value: null },
      { name: "granel", displayName: "Granel", value: "" },
      { name: "indisponivelGranel", displayName: "Indisponível a Granel", value: "" },
      { name: "indisponivelEngarrafado", displayName: "Indisponível Engarrafado", value: "" },
      { name: "produtoAcabado", displayName: "Produto Acabado", value: "" },
      { name: "geraDocumento", displayName: "Gera Documento", value: "" },
      { name: "criaConta", displayName: "Cria Conta", value: "" },
      { name: "capacidadeVenda", displayName: "Capacidade de Venda", value: "" },
      { name: "selagem", displayName: "Selagem", value: "" },
      { name: "circulaSelado", displayName: "Circula Selado", value: "" },
      { name: "mudaNivel", displayName: "Muda Nível", value: "" },
      { name: "contaSemRegisto", displayName: "Conta Sem Registo", value: "" },
      { name: "contaSemAno", displayName: "Conta Sem Ano", value: "" },
      { name: "cobraServico", displayName: "Cobra Servico", value: "" },
      { name: "cobraTaxa", displayName: "Cobra Taxa", value: "" },
      { name: "agendaFiscalizacao", displayName: "Agenda Fiscalizção", value: "" },
      { name: "movimentoAssociado", displayName: "Movimento Associado", value: "" },
      { name: "desclassificaPara", displayName: "Desclassifica Para", value: null },
      { name: "percentagemCapacidadeVenda", displayName: "Percentagem Capacidade Venda", value: null },
      { name: "percentagemCobraTaxa", displayName: "Percentagem Cobra Taxa", value: null },
    ],
    data: {
      "idTipoMovimento": null,
      "idTipoFormulario": null,
      "idproduto": null,
      "idProdutoDestino": null,
      "idTipoConta": null,
      "idTipoContaDestino": null,
      "comMencao": false,
      "mudaProduto": false,
      "mudaNivel": false,
      "mudaConta": false,
      "deselagem": false,
      "circulaSelado": false,
      "selagem": false,
      "selado": false,
      "geraCobranca": false,
      "alteraTitularidade": false,
      // "calculoCapacidade": false,
      "capacidadeVenda": false,
      "formula": "",
      "descritivoRegra": "",
      "regraCapacidadeMenor": null,
      "regraCapacidadeMaior": null,
      "idTipoContaEntrada": null,
      "idTipoContaSaida": null,
      "idMovimento": null,
      "idMovimentoAssociado": null,
      "idEstado": null,
      "emHistorico": false,
      "movementDecaptiveOrigin": false,
      "movementCaptive": false,
      "movementDecaptiveDestination": false,
      "idFamiliaProdutodestino": null,
      "idFamiliaProdutoOrigim": null,
      "idContaCurrentadestino": null,
      "idContaCurrentaOrigim": null,
      "idMencao": null,
      "idMovimentoTesouraria": null,
      "validaSaldo": false,
      "efetuaCativacao": false,
      "codArtg":"",
      "req_capacidade_onethird" : false,
      "req_capacidade_seventyfive" : false,
      "forSalesCapacityCalculation":  false,
      "percentagemCapacidadeVenda": 0,
      "percentagemCobraTaxa": 0
    },
    popupadmin: ""
  }

  componentDidMount() {

    // (async () => {
    //   const tipoFormulario = await services.apiCall.requestApi("allservice/TipoFormulario/GetAll", this.state.filters, 'post')
    //   this.setState({ tipoFormulario });
    // })();
    (async () => {
      let Filters = {
        CurrentAccount: true
      }
      let filters = {...this.state.filters, Filters}
      const estatuto = await services.apiCall.requestApi("Estatuto/GetAll", filters, 'post')
      this.setState({ estatuto });
      console.log("ESTATUTOS" , estatuto)
      // const tipoFormulario = await services.apiCall.requestApi("RegrasMovimento/GetFluxoFromEstatuto", filters, 'get');
      const produtosFormulario = await services.apiCall.requestApi("RegrasMovimento/GetProdutosFromFluxo", filters, 'get');
      const produtosDestinoFormulario = produtosFormulario;

      const produtosTpContaFormulario = await services.apiCall.requestApi("RegrasMovimento/GetTipoContaFromFluxoAndProduto", filters, 'get');
      const produtosTpContaDestinoFormulario = produtosTpContaFormulario;
      
    this.setState({ estatuto,produtosFormulario, produtosDestinoFormulario,produtosTpContaFormulario,produtosTpContaDestinoFormulario});
    })();
    
    // (async () => {
    //   const movemento = await services.apiCall.requestApi("allservice/TipoMovimento/GetAll", this.state.filters, 'post')
    //   this.setState({ movemento });
    // })();

  }

  handleCancel = () => {
    this.props.history.push({
      pathname: "/conta_corrente"
    })
  }

  handleChange = (value, type, id, e) => {
    const regrasMovimentoForm = this.state.regrasMovimentoForm;

    regrasMovimentoForm.forEach(elem => { 
      if (elem.name == type){
        if (value == true){
          elem.value = 1;
        }
        else if (value == false){
          elem.value = 0;
        }
      }
    });

    if (type == "capacidadeVenda" && value == true){
      $("#pcv-input").removeClass("d-none");
    }
    else if (type == "capacidadeVenda" && value == false){
      $("#pcv-input").addClass("d-none");
    }

    this.setState({ regrasMovimentoForm: regrasMovimentoForm });
  }

  handleChangeTipoFormulario = (e) => {
    this.setState({ data: {...this.state.data, "idTipoFormulario": null, "idproduto": null, "idProdutoDestino": null, "idTipoConta": null, "idTipoContaDestino": null }, regrasMovimento: [] });
    const filters = {IDTipoFormulario: e};
    (async () => {
      // const produtosFormulario = await services.apiCall.requestApi("RegrasMovimento/GetProdutosFromFluxo", filters, 'get');
      this.setState({ data: {...this.state.data, "idTipoFormulario": e } });
      
    })();
  }

  handleChangeProduto = (e) => {
    this.setState({ data: {...this.state.data, "idproduto": null, "idProdutoDestino": null, "idTipoConta": null }, regrasMovimento: []});
    const filters = { IDTipoFormulario: this.state.data.idTipoFormulario, IDProduto: e };
    (async () => {

      // const produtosDestinoFormulario = await services.apiCall.requestApi("RegrasMovimento/GetProdutosFromFluxo", filters, 'get');

      // if (produtosDestinoFormulario.length > 0){
      //   this.setState({ produtosDestinoFormulario, data: {...this.state.data, "idproduto": e } });
      // }

      //   const produtosTpContaFormulario = await services.apiCall.requestApi("RegrasMovimento/GetTipoContaFromFluxoAndProduto", filters, 'get');
      this.setState({data: {...this.state.data, "idproduto": e } });

      
    })();
  }

  handleChangeProdutoDestino = (e) => {
    this.setState({ data: {...this.state.data, "idProdutoDestino": null, "idTipoConta": null }, regrasMovimento: []});
    const filters = { IDTipoFormulario: this.state.data.idTipoFormulario, IDProduto: this.state.data.idproduto, IDProdutoDestino: e };
    (async () => {
      // const produtosTpContaFormulario = await services.apiCall.requestApi("RegrasMovimento/GetTipoContaFromFluxoAndProduto", filters, 'get');
      this.setState({data: {...this.state.data, "idProdutoDestino": e } });
    })();
  }

  handleChangeTipoConta = (e) => {
    this.setState({ data: {...this.state.data, "idTipoConta": null }, regrasMovimento: []});
    var prodDest = 0;
    if (this.state.data.idProdutoDestino != null){
      prodDest = this.state.data.idProdutoDestino;
    }
    const filters = {IDEstatuto: this.state.data.codEstatuto, IDTipoFormulario: this.state.data.idTipoFormulario, IDProduto: this.state.data.idproduto, IDTipoConta: e, IDProdutoDestino: prodDest };

    (async () => {
      // const produtosTpContaDestinoFormulario = await services.apiCall.requestApi("RegrasMovimento/GetTipoContaFromFluxoAndProduto", filters, 'get');
      

      // if (produtosTpContaDestinoFormulario.length > 0){
       this.setState({ data: {...this.state.data, "idTipoConta": e } });
      // }
      // else{
        (async () => {
          const regrasMovimento = await services.apiCall.requestApi("RegrasMovimento/GetRegrasMovimento", filters, 'get');
          const regrasMovimentoForm = this.state.regrasMovimentoForm;
          if(regrasMovimento.length > 0){
            const keys = Object.keys(regrasMovimento[0]);
            
      
            for (let index = 0; index < keys.length; index++) {
              for (let index2 = 0; index2 < regrasMovimentoForm.length; index2++) {       
                if(regrasMovimentoForm[index2].name == keys[index]) {
                  regrasMovimentoForm[index2].value = regrasMovimento[0][keys[index]];
                  break;
                }
                else{
                  continue;
                }   
              }      
            }
          }
          
    
          this.setState({ regrasMovimento, data: {...this.state.data, "idTipoConta": e }, regrasMovimentoForm });
        })();
      // }
    })();    
  }

  handleChangeTipoContaDestino = (e) => {
    this.setState({ data: {...this.state.data, "idTipoContaDestino": null }, regrasMovimento: []});
    var prodDest = 0;
    if (this.state.data.idProdutoDestino != null){
      prodDest = this.state.data.idProdutoDestino;
    }

    const filters = { IDTipoFormulario: this.state.data.idTipoFormulario, IDProduto: this.state.data.idproduto, IDTipoConta: this.state.data.idTipoConta, IDTipoContaDestino: e, IDProdutoDestino: prodDest };
    (async () => {
      const regrasMovimento = await services.apiCall.requestApi("RegrasMovimento/GetRegrasMovimento", filters, 'get');

      const keys = Object.keys(regrasMovimento[0]);
      const regrasMovimentoForm = this.state.regrasMovimentoForm;

      for (let index = 0; index < keys.length; index++) {
        for (let index2 = 0; index2 < regrasMovimentoForm.length; index2++) {       
          if(regrasMovimentoForm[index2].name == keys[index]) {
            regrasMovimentoForm[index2].value = regrasMovimento[0][keys[index]];
            break;
          }
          else{
            continue;
          }   
        }      
      }

      this.setState({ regrasMovimento, data: {...this.state.data, "idTipoContaDestino": e }, regrasMovimentoForm });
    })();
  }

  toNullableByte(value) {
    if (value === "" || value === undefined || value === null) return null;
    return parseInt(value);
  }


  handleGraver = async () => {
    if (Number(this.state.data.percentagemCapacidadeVenda) > 100 || Number(this.state.data.percentagemCapacidadeVenda) < 0)
    {
      toast.error("Introduza uma percentagem válida.");
      return;
    }

    const desclassifica = this.state.regrasMovimentoForm.find(w => w.name === 'desclassificaPara').value;

    const sendObj = { 
      IDTipoFormulario: this.state.data.idTipoFormulario,
      IDProduto: this.state.data.idproduto,
      IDProdutoDestino: this.state.data.idProdutoDestino,
      IDTipoConta: this.state.data.idTipoConta,
      IDTipoContaDestino: this.state.data.idTipoContaDestino,
      MencaoComplementar: this.toNullableByte(this.state.regrasMovimentoForm.find(w => w.name === 'mencaoComplementar').value),
      Granel: this.toNullableByte(this.state.regrasMovimentoForm.find(w => w.name === 'granel').value),
      IndisponivelGranel: this.toNullableByte(this.state.regrasMovimentoForm.find(w => w.name === 'indisponivelGranel').value),
      IndisponivelEngarrafado: this.toNullableByte(this.state.regrasMovimentoForm.find(w => w.name === 'indisponivelEngarrafado').value),
      ProdutoAcabado: this.toNullableByte(this.state.regrasMovimentoForm.find(w => w.name === 'produtoAcabado').value),
      GeraDocumento: this.toNullableByte(this.state.regrasMovimentoForm.find(w => w.name === 'geraDocumento').value),
      CriaConta: this.toNullableByte(this.state.regrasMovimentoForm.find(w => w.name === 'criaConta').value),
      CapacidadeVenda: this.toNullableByte(this.state.regrasMovimentoForm.find(w => w.name === 'capacidadeVenda').value),
      Selagem: this.toNullableByte(this.state.regrasMovimentoForm.find(w => w.name === 'selagem').value),
      CirculaSelado: this.toNullableByte(this.state.regrasMovimentoForm.find(w => w.name === 'circulaSelado').value),
      MudaNivel: this.toNullableByte(this.state.regrasMovimentoForm.find(w => w.name === 'mudaNivel').value),
      ContaSemRegisto: this.toNullableByte(this.state.regrasMovimentoForm.find(w => w.name === 'contaSemRegisto').value),
      ContaSemAno: this.toNullableByte(this.state.regrasMovimentoForm.find(w => w.name === 'contaSemAno').value),
      CobraServico: this.toNullableByte(this.state.regrasMovimentoForm.find(w => w.name === 'cobraServico').value),
      CobraTaxa: this.toNullableByte(this.state.regrasMovimentoForm.find(w => w.name === 'cobraTaxa').value),
      AgendaFiscalizacao: this.toNullableByte(this.state.regrasMovimentoForm.find(w => w.name === 'agendaFiscalizacao').value),
      MovimentoAssociado: this.toNullableByte(this.state.regrasMovimentoForm.find(w => w.name === 'movimentoAssociado').value),
      DesclassificaPara: desclassifica != null ? desclassifica.toString() : null,
      PercentagemCapacidadeVenda: parseFloat(this.state.data.percentagemCapacidadeVenda),
      PercentagemCobraTaxa: parseFloat(this.state.data.percentagemCobraTaxa),
      IDEstatuto : parseInt(this.state.codEstatuto)
    }

    await services.apiCall.requestApi('RegrasMovimento/GravarRegra', sendObj, 'post');
  }

  // handleChangeTipoMovimento = (e) => {
  //   this.setState({ dadosMovimento: [], data: {...this.state.data, "idTipoMovimento": null } });
  //   const filters = { IDTipoMovimento: e};
  //   (async () => {
  //     const dadosMovimento = await services.apiCall.requestApi("RegrasMovimento/GetTipoMovimentoFromID", filters, 'get');
  //     this.setState({ dadosMovimento, data: {...this.state.data, "idTipoMovimento": e } });
      
  //   })();
  // }

  handleChangePCV = (e) => {    
    this.setState({ data: {...this.state.data, "percentagemCapacidadeVenda": e.target.value } });
  }

  handleChangeCBTX = (e) => {    
    this.setState({ data: {...this.state.data, "percentagemCobraTaxa": e.target.value } });
  }

  // handleSaveTipoMovimento = async () => {
  //   if (Number(this.state.data.percentagemCapacidadeVenda) > 100 || Number(this.state.data.percentagemCapacidadeVenda) < 0)
  //   {
  //     toast.error("Introduza uma percentagem válida.");
  //     return;
  //   }

  //   const sendObj = { 
  //     IDTipoMovimento: this.state.data.idTipoMovimento,
  //     PercentagemCapacidadeVenda: +this.state.data.percentagemCapacidadeVenda,
  //   }
  //   console.log("sendObj");
  //   console.log(sendObj);
  //   await services.apiCall.requestApi('RegrasMovimento/GravarTipoMovimento', sendObj, 'post');

  // }
  handleEstatutoChange(codEstatuto) {
    if (codEstatuto) {
      this.setState({
        codEstatuto
      }, async () => {
        await this.getEstatutoRules(codEstatuto)     
      })
    } else {
      return
    }
    this.setState({ tipoFormulario: [], data: {...this.state.data, "idTipoFormulario": null, "idproduto": null, "idProdutoDestino": null, "idTipoConta": null, "idTipoContaDestino": null }, regrasMovimento: [] });
    const filters = {IDEstatuto: codEstatuto};
    (async () => {
      const tipoFormulario = await services.apiCall.requestApi("RegrasMovimento/GetFluxoFromEstatuto", filters, 'get');
      this.setState({ tipoFormulario, data: {...this.state.data, "codEstatuto": codEstatuto } });
    })();
  }

   getEstatutoRules = async (codEstatuto) => {
      const filters = {
        Id: codEstatuto,
      };
  
      const response = await services.apiCall.requestApi("SIVDP/SaveRule/GetById", filters, 'post')
      if (response) {
        if(response.idRegra) {
          let { submitData, submitDataOff } = { ...this.state }
          let data = {} 
          let IDRegra 
          data["IDRegra"] = response.idRegra
          IDRegra = response.idRegra
  
          Object.keys(submitData).map(key => {
            //response[key] 
            if(key === "idTipoAcao" ||
            key === "idTipoConta" ||
            key === "idCategoriaProduto" ||
            key === "idTipoMovimento") {
              if(response[key] === null || response[key] === "") {
                data[key] = []
              }
              else {
                data[key] = this.changeFormat(response[key], "number", "toArray")
              }
            }
  
            else if(key === "idProduto") {
              if(response[key] === null || response[key] === "") {
                data[key] = []
              }
              else {
                data[key] = this.changeFormat(response[key], "NaN", "toArray")
              }
            }
            else if(key === "idMovimento") {
              if(!response[key]) {
                data[key] = []
              }
              else if (Array.isArray(response[key])) {
                data[key] = response[key]
              }
            }
            else {
              data[key] = response[key]
            }
          })
          //data object ready for submitData
          console.log("777 data", data)  
          this.setState({ 
            submitData: data, 
            submitDataOff,
            IDRegra 
          },()=>{
            console.log("Submit Data",submitData)
            this.movimentoWithFilter('submitData')
          })
        }
      }
      console.log("🚀 ~ file: Nivel1.js ~ line 78 ~ Nivel1Form ~ response", response);
    }
  render() {
    const { estatuto , tipoFormulario, produtosFormulario, produtosDestinoFormulario, produtosTpContaFormulario, produtosTpContaDestinoFormulario, regrasMovimento, regrasMovimentoForm, dadosMovimento, movemento } = this.state
    console.log(this.state.regrasMovimentoForm);
    console.log(regrasMovimentoForm);
    return (
      <div className="container-fluid pb-5">
        <div className="p-3 bg-white border rounded mb-2">
          <div>
            <InstructionMessage message={message} messageFor="nivel" />
          </div>
          <label>Estatuto</label>
          <div className="row mb-2" id="sticky-seachmenu">
            <div className="col-auto position-relative">
              <Select
                showSearch
                optionFilterProp="children"
                maxTagTextLength={ 3 }
                suffixIcon={ <DownCircleTwoTone /> }
                placeholder="Selecione o estatuto"
                className="estatoSelect"
                style={ { width: '500px' } }
                value={ this.state.codEstatuto }
                onChange={ (e) => this.handleEstatutoChange(e) }
              >
                <Option value="" >Selecione o estatuto</Option>
                { (estatuto && !!estatuto.length) && estatuto.map((item, index) => (
                  <Option key={ index } value={ +item.codEstatuto }>{ item.estatuto }</Option>
                )) }
              </Select>
              <div class="drop-icon">
                <i class="fas fa-chevron-down"></i>
              </div>
            </div>
            <div className="pl-0">
              <Button className="mr-2 btn-ivdp-primary btn-theme k-primary" onClick={() => this.handleGraver()} >Gravar Regra</Button>
            </div>
            <div className="col-auto pl-0">
              <Button className="btn-ivdp-secondary" onClick={() => this.handleCancel()} >Cancelar</Button>
            </div>
          </div>
          {
            tipoFormulario && !!tipoFormulario.length && this.state.data.codEstatuto &&
            <>
          <label>Fluxo vínico</label>
          <div className="row" id="sticky-seachmenu">
            <div className="col-auto position-relative">
              <Select
                showSearch
                optionFilterProp="children"
                // maxTagTextLength={ 3 }
                placeholder="Selecione o fluxo vínico"
                className="estatoSelect"
                //value={this.state.data.idTipoFormulario}
                onChange={(e) => this.handleChangeTipoFormulario(e)}
                style={{ width: "500px" }}
              >
                <Option disabled >Selecione o fluxo vínico</Option>
                {(tipoFormulario && !!tipoFormulario.length) && tipoFormulario.map((item, index) => (
                  <Option key={index} value={item.idTipoFormulario}>{item.descricao}</Option>
                ))}
              </Select>
              <div className="drop-icon">
                <i className="fas fa-chevron-down"></i>
              </div>
            </div>
          
          </div>
          </>
            }
          {
            produtosFormulario && !!produtosFormulario.length && this.state.data.idTipoFormulario &&
            <>
            <div className="mt-3">
              <label>Produto</label>
              <div className="row" id="sticky-seachmenu">
                <div className="col-auto position-relative">
                  <Select
                    showSearch
                    optionFilterProp="children"
                    // maxTagTextLength={ 3 }
                    placeholder="Selecione o produto"
                    className="estatoSelect"
                    //value={this.state.data.idProduto}
                    onChange={(e) => this.handleChangeProduto(e)}
                    style={{ width: "500px" }}
                  >
                    <Option disabled >Selecione o produto</Option>
                    {(produtosFormulario && !!produtosFormulario.length) && produtosFormulario.map((item, index) => (
                      <Option key={index} value={item.idproduto}>{item.desproduto}</Option>
                    ))}
                  </Select>
                  <div className="drop-icon">
                    <i className="fas fa-chevron-down"></i>
                  </div>
                </div>
              </div>
            </div>
            </>
          }

          {
            produtosDestinoFormulario && !!produtosDestinoFormulario.length && this.state.data.idTipoFormulario &&
            <>
            <div className="mt-3">
              <label>Produto Destino</label>
              <div className="row" id="sticky-seachmenu">
                <div className="col-auto position-relative">
                  <Select
                    showSearch
                    optionFilterProp="children"
                    // maxTagTextLength={ 3 }
                    placeholder="Selecione o produto destino"
                    className="estatoSelect"
                    //value={this.state.data.idTipoFormulario}
                    onChange={(e) => this.handleChangeProdutoDestino(e)}
                    style={{ width: "500px" }}
                  >
                    <Option disabled >Selecione o produto destino</Option>
                    {(produtosDestinoFormulario && !!produtosDestinoFormulario.length) && produtosDestinoFormulario.map((item, index) => (
                      <Option key={index} value={item.idproduto}>{item.desproduto}</Option>
                    ))}
                  </Select>
                  <div className="drop-icon">
                    <i className="fas fa-chevron-down"></i>
                  </div>
                </div>
              </div>
            </div>
            </>
          }

          {
            produtosDestinoFormulario && !!produtosDestinoFormulario.length && (this.state.data.idproduto || this.state.data.idProdutoDestino) &&
            <>
            <div className="mt-3">
              <label>Tipo de Conta</label>
              <div className="row" id="sticky-seachmenu">
                <div className="col-auto position-relative">
                  <Select
                    showSearch
                    optionFilterProp="children"
                    // maxTagTextLength={ 3 }
                    placeholder="Selecione o tipo de conta"
                    className="estatoSelect"
                    //value={this.state.data.idTipoFormulario}
                    onChange={(e) => this.handleChangeTipoConta(e)}
                    style={{ width: "500px" }}
                  >
                    <Option disabled >Selecione o tipo de conta</Option>
                    {(produtosTpContaFormulario && !!produtosTpContaFormulario.length) && produtosTpContaFormulario.map((item, index) => (
                      <Option key={index} value={item.idTipoConta}>{item.codTipoConta} - {item.descricao}</Option>
                    ))}
                  </Select>
                  <div className="drop-icon">
                    <i className="fas fa-chevron-down"></i>
                  </div>
                </div>
              </div>
            </div>
            </>
          }

          {
            produtosTpContaDestinoFormulario && !!produtosTpContaDestinoFormulario.length && (this.state.data.idproduto || this.state.data.idProdutoDestino) &&
            <>
            <div className="mt-3">
              <label>Tipo de Conta Destino</label>
              <div className="row" id="sticky-seachmenu">
                <div className="col-auto position-relative">
                  <Select
                    showSearch
                    optionFilterProp="children"
                    // maxTagTextLength={ 3 }
                    placeholder="Selecione o tipo de conta"
                    className="estatoSelect"
                    //value={this.state.data.idTipoFormulario}
                    onChange={(e) => this.handleChangeTipoContaDestino(e)}
                    style={{ width: "500px" }}
                  >
                    <Option disabled >Selecione o tipo de conta</Option>
                    {(produtosTpContaDestinoFormulario && !!produtosTpContaDestinoFormulario.length) && produtosTpContaDestinoFormulario.map((item, index) => (
                      <Option key={index} value={item.idTipoConta}>{item.codTipoConta} - {item.descricao}</Option>
                    ))}
                  </Select>
                  <div className="drop-icon">
                    <i className="fas fa-chevron-down"></i>
                  </div>
                </div>
              </div>
            </div>
            </>
          }

          { produtosTpContaDestinoFormulario && !!produtosTpContaDestinoFormulario.length && this.state.data.idTipoConta &&
            <>
              <div className="mt-3">
                <h4>Regras (Sim ou Não)</h4>
                <div className="p-3 border rounded">
                  <div className="row">
                    {
                      regrasMovimentoForm.map((item, index) => (
                        
                        <div className="col-6" key={index}>
                          { item.name != "desclassificaPara" && item.name != "capacidadeVenda" && item.name != "cobraTaxa" && item.name != "percentagemCapacidadeVenda" && item.name != "percentagemCobraTaxa" &&
                            <>
                          <div className="custom-control custom-switch">
                            
                            <input
                              type="checkbox"
                              name={item.name}
                              checked={item.value}
                              onChange={(e) => this.handleChange(e.target.checked, e.target.name, item.id, e)}
                              className="custom-control-input"
                              id={item.name}
                            />
                            
                            <label className="custom-control-label" htmlFor={item.name}>{ item.displayName }</label>
                          </div>
                          </>
                          }
                          { item.name == "desclassificaPara" && item.name != "percentagemCapacidadeVenda" && item.name != "percentagemCobraTaxa" &&
                            <>
                          <div> 
                            <label className="mr-2" htmlFor={item.name}>{ item.displayName }</label>
                            <input
                              type="number"
                              name={item.name}
                              checked={this.state.regrasMovimentoForm[index].value}
                              onChange={(e) => this.handleChange(e.target.checked, e.target.name, item.id, e)}
                              className="regras-numberBox input-1 k-textbox"
                              id={item.name}
                            />
                          </div>
                          </>
                          }
                          { item.name == "capacidadeVenda" && item.name != "percentagemCapacidadeVenda" && item.name != "percentagemCobraTaxa" &&
                            <>
                          <div className="custom-control custom-switch"> 
                            <input
                              type="checkbox"
                              name={item.name}
                              checked={this.state.regrasMovimentoForm[index].value}
                              onChange={(e) => this.handleChange(e.target.checked, e.target.name, item.id, e)}
                              className="custom-control-input"
                              id={item.name}
                            />
                            <label className="custom-control-label mr-2" htmlFor={item.name}>{ item.displayName }</label>
                            { this.state.regrasMovimentoForm[index].value == 1 &&
                              <>
                              <input
                                type="number"
                                checked={this.state.regrasMovimentoForm[18].value}
                                onChange={(e) => this.handleChangePCV(e)}
                                className="regras-numberBox input-1 k-textbox"
                                id="pcv-input"
                              />
                              </>
                            }
                            { this.state.regrasMovimentoForm[index].value == 0 &&
                              <>
                              <input
                                type="number"
                                checked={this.state.regrasMovimentoForm[18].value}
                                onChange={(e) => this.handleChangePCV(e)}
                                className="regras-numberBox input-1 k-textbox d-none"
                                id="pcv-input"
                              />
                              </>
                            }
                          </div>
                          </>
                          }
                          { item.name == "cobraTaxa" && item.name != "percentagemCapacidadeVenda" && item.name != "percentagemCobraTaxa" &&
                            <>
                          <div className="custom-control custom-switch"> 
                            <input
                              type="checkbox"
                              name={item.name}
                              checked={this.state.regrasMovimentoForm[index].value}
                              onChange={(e) => this.handleChange(e.target.checked, e.target.name, item.id, e)}
                              className="custom-control-input"
                              id={item.name}
                            />
                            <label className="custom-control-label mr-2" htmlFor={item.name}>{ item.displayName }</label>
                            { this.state.regrasMovimentoForm[index].value == 1 &&
                              <>
                              <input
                                type="number"
                                checked={this.state.regrasMovimentoForm[19].value}
                                onChange={(e) => this.handleChangeCBTX(e)}
                                className="regras-numberBox input-1 k-textbox"
                                id="cbtx-input"
                              />
                              </>
                            }
                            { this.state.regrasMovimentoForm[index].value == 0 &&
                              <>
                              <input
                                type="number"
                                checked={this.state.regrasMovimentoForm[19].value}
                                onChange={(e) => this.handleChangeCBTX(e)}
                                className="regras-numberBox input-1 k-textbox d-none"
                                id="cbtx-input"
                              />
                              </>
                            }
                          </div>
                          </>
                          }
                        </div>
                      ))
                    }
                  </div>
                </div>
              </div>
            </>
          }
          {/* <div className="mt-5">
            <InstructionMessage message={message2} messageFor="nivel" />
          </div>
          <label>Tipo de movimento</label>
          <div className="row" id="sticky-seachmenu">
            <div className="col-auto position-relative">
              <Select
                showSearch
                optionFilterProp="children"
                // maxTagTextLength={ 3 }
                placeholder="Selecione o tipo de movimento"
                className="estatoSelect"
                //value={this.state.data.idTipoFormulario}
                onChange={(e) => this.handleChangeTipoMovimento(e)}
                style={{ width: "500px" }}
              >
                <Option disabled >Selecione o tipo de movimento</Option>
                {(movemento && !!movemento.length) && movemento.map((item, index) => (
                  <Option key={index} value={item.idTipoMovimento}>{item.codTipoMovimento} - {item.tipoMovimento}</Option>
                ))}
              </Select>
              <div className="drop-icon">
                <i className="fas fa-chevron-down"></i>
              </div>
            </div>
            <div className="pl-0">
              <Button className="mr-2 btn-ivdp-primary btn-theme k-primary" onClick={() => this.handleSaveTipoMovimento()} >GRAVAR TIPO DE MOVIMENTO</Button>
            </div>
            <div className="col-auto pl-0">
              <Button className="btn-ivdp-secondary" onClick={() => this.handleCancel()} >CANCELAR</Button>
            </div>
          </div>

          { dadosMovimento && !!dadosMovimento.length &&
            <>
                <div className="row">
                    <div className="col-md-4">
                        <div className="input-box active-grey">
                          <label className="mr-2" htmlFor="pcv">Percentagem Capacidade Venda</label>
                          <input
                              type="number"
                              style={{ width: "100%" }}
                              className="input-1"
                              name="pcv"
                              defaultValue={this.state.dadosMovimento[0].percentagemCapacidadeVenda}
                              label="Percentagem Capacidade Venda"
                              onChange={(e) => this.handleChangePCV(e)}
                              id="pcv1"
                            />
                        </div>
                    </div>
                </div>
            </>
          }  */}

        </div>
        
        {

          <div className="modal center" id="popupadmin" >
             <div className="modal-dialog modal-dialog-centered">
              {this.state.popupadmin}
            </div>
          </div>

        }

      </div>
    )
  }

}

export default Nivel2Form;